import { Component, OnInit } from "@angular/core";

@Component({
  selector: "Card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.sass"],
})
export class CardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
